export default {
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  filters: {
    amenities: {
      title: "Service & Amenities"
    }
  },
  directions: {
    route: {
      avoid_highways: "Avoid highways"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# day} other {# days}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# mins}}\
`
  },
  locations: {
    distance: "{distance, number, distance} {unit}"
  },
  info_window: {
    services: "Service & Amenities",
    opening_hours: {
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  fuels: {
    low_octane_gasoline: "Bronze",
    midgrade_gasoline: "Silver",
    premium_diesel: "Shell V-Power Diesel",
    premium_gasoline: "Shell V-Power NiTRO+ Premium Gasoline",
    shell_regular_diesel: "Ultra Low Sulphur Diesel"
  },
  amenities: {
    guarded_car_park: "Secured parking",
    deli_cafe: "delicafé by Shell",
    self_service: "Self-serve",
    service_bay: "Service Bay",
    standard_toilet: "Washroom",
    toilet: "Washroom",
    twenty_four_hour: "24-Hour",
    wifi: "Wi-Fi",
    distance_units: {
      km: "kilometres "
    }
  }
}
